import { Tooltip, TooltipTrigger, TooltipContent } from "./ui/tooltip";

const TOOLTIP = "Thank you for being one of the first members of Blinxd. You have full Pro access for 1 year!";

function Medallion({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
      <defs>
        <linearGradient id="fm-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F7DE8B" />
          <stop offset="1" stopColor="#C9972F" />
        </linearGradient>
      </defs>
      <path d="M12 1.2 L20.5 5.6 V12.4 C20.5 17.4 12 22.6 12 22.6 C12 22.6 3.5 17.4 3.5 12.4 V5.6 Z"
        fill="url(#fm-gold)" stroke="#0B0B0B" strokeWidth="0.9" strokeLinejoin="round" />
      <circle cx="12" cy="11" r="5.4" fill="#0B0B0B" />
      <path d="M12 7.1 l1.25 2.53 2.79 0.4 -2.02 1.97 0.48 2.78 -2.5 -1.31 -2.5 1.31 0.48 -2.78 -2.02 -1.97 2.79 -0.4 z"
        fill="#12B5A5" />
    </svg>
  );
}

export default function FoundingBadge({ size = 18, label = false, className = "" }) {
  const inner = label ? (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-ink px-2.5 py-1 border border-[#C9972F]/50 ${className}`}>
      <Medallion size={size} />
      <span className="text-[11px] font-mono tracking-wide text-[#F7DE8B]">Founding Member</span>
    </span>
  ) : (
    <span className={`inline-flex ${className}`}><Medallion size={size} /></span>
  );

  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <span data-testid="founding-badge" className="cursor-help inline-flex">{inner}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[240px] bg-ink text-white text-center leading-snug">
        {TOOLTIP}
      </TooltipContent>
    </Tooltip>
  );
}
